import {
  colorIconPrimary,
  colorIconSecondary,
} from '@spaced-out/ui-design-system/lib/styles/variables/_color';


export const FEATURE_REQUEST_URL =
  'https://form.asana.com/?k=HHJwBxMRKYi4zwNiU_qYVg&d=713022220213973';

export const CREATE_SUPPORT_TICKET_URL =
  'https://support.sensehq.co/hc/en-us/requests/new';

export const SUPPORT_URL = 'https://support.sensehq.co';

// TODO: Import from genesis later
export const PAGE_NAME_LIST = Object.freeze({
  dashboard: {
    title: 'Dashboard',
    iconName: 'house',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  engage: {
    title: 'Engage',
    iconName: 'bullseye-pointer',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  journeys: {
    title: 'Journeys',
    iconName: 'bullseye-pointer',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  workflows: {
    title: 'Workflows',
    iconName: 'bullseye-pointer',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  trm: {
    title: 'TRM',
    iconName: 'screen-users',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  analytics: {
    title: 'Analytics',
    iconName: 'chart-column',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  messaging: {
    title: 'Messaging',
    iconName: 'messages',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  chatbot: {
    title: 'Chatbots',
    iconName: 'message-bot',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  referrals: {
    title: 'Referrals',
    iconName: 'user-check',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  records: {
    title: 'Records',
    iconName: 'folder-open',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  bulkCleanup: {
    title: 'Bulk Cleanup',
    iconName: 'retweet',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  support: {
    title: 'Support',
    iconName: 'headset',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  audit: {
    title: 'Audit',
    iconName: 'print-magnifying-glass',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  timeline: {
    title: 'Timeline',
    iconName: 'timeline',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  people: {
    title: 'People',
    iconName: 'people-group',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  jobs: {
    title: 'Jobs',
    iconName: 'briefcase',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  contacts: {
    title: 'Contacts',
    iconName: 'address-card',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  meetings: {
    title: 'Meetings',
    iconName: 'calendars',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  contacts3: {
    title: 'Contacts',
    iconName: 'browser',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  tracking: {
    title: 'Tracking',
    iconName: 'user-check',
    iconType: 'duotone',
  },
  earnings: {
    title: 'Earnings',
    iconName: 'wallet',
    iconType: 'duotone',
  },
  settings: {
    title: 'Settings',
    iconName: 'gear',
    iconType: 'duotone',
  },
  broadcast: {
    title: 'Broadcast',
    iconName: 'bullhorn',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
  tasks: {
    title: 'Tasks',
    iconName: 'list-check',
    iconType: 'duotone',
    iconSwapOpacity: true,
  },
});

export const startsWithSelectedKeyMap = {
  '/tasks': 'tasks',
  '/people/leads': 'people.leads',
  '/people/lists': 'people.lists',
  '/people/csv-lists': 'people.lists',
  '/people/ats-lists': 'people.lists',
  '/people/activity': 'people.activity',
  '/people/candidates/active': 'people.candidates.active',
  '/people': 'people.candidates',
  '/recruiter-hub-v2': 'recruiter-hub-v2',
  '/jobs/recruiter-hub': 'jobs.active',
  '/jobs/active': 'jobs.active',
  '/jobs/lists': 'jobs.lists',
  '/crm/candidate': 'crm.candidates',
  '/mailbox': 'mailbox',
  '/talent-pools': 'talent-pools',
  '/crm': 'jobs.crm',
  '/reports': 'analytics',
  '/pages/sites': 'pages.sites',
  '/referralv2': 'referral',
  '/settings/data-integration': 'settings.data-integration',
  '/data-audit': 'data-audit',
  '/settings': 'configuration',
  '/journey': 'journeys',
  '/messages/hv-broadcasts': 'messages.hv-broadcasts',
  '/messages/queues': 'messages.queues',
  '/audit': 'analytics',
  '/schedule': 'analytics',
} as const;

const startsWithTrmSelectedKeyMap = {
  '/trm#/onboarding': 'jobs.onboarding',
  '/trm#/settings/hiring-plan-setup/hiring-plans': 'jobs.hiringplan',
  '/trm#/internal-job-board': 'jobs.internal-posting',
  '/trm#/aop/overview': 'jobs.aop',
  '/trm#/candidates': 'people.trm-candidates',
  '/trm#/settings/career-page': 'trm-career-page',
  '/trm#/referrals/jobs': 'trm-referral',
  '/trm#/overview': 'dashboard.overview_trm',
  '/trm#/approvals': 'dashboard.approvals_trm',
  '/trm#/jobs': 'jobs.trm',
  '/trm#/report-analytics': 'analytics',
} as const;

export const trmRoutesTitles = [
  {hash: '#/onboarding', title: 'Onboarding', icon: 'briefcase'},
  {
    hash: '#/report-analytics',
    title: 'CRM Report & Analytics',
    icon: 'chart-column',
  },
  {
    hash: '#/settings/hiring-plan-setup/hiring-plans',
    title: 'Hiring Plans',
    icon: 'list-tree',
  },
  {hash: '#/settings/career-page', title: 'Careers Page', icon: 'browser'},
  {hash: '#/settings/account/my-profile', title: 'CRM Settings', icon: 'gear'},
  {hash: '#/settings', title: 'CRM Settings', icon: 'gear'},
  {
    hash: '#/internal-job-board',
    title: 'Internal Job Portal',
    icon: 'briefcase',
  },
  {
    hash: '#/aop/overview',
    title: 'Annual Operating Plan',
    icon: 'calendar-lines-pen',
  },
  {hash: '#/candidates', title: 'Candidates', icon: 'screen-users'},
  {hash: '#/referrals/jobs', title: 'Referrals', icon: 'user-check'},
  {hash: '#/overview', title: 'Overview', icon: 'house'},
  {hash: '#/approvals', title: 'Approvals', icon: 'file-circle-check'},
  {hash: '#/jobs', title: 'Jobs', icon: 'briefcase'},
] as const;

export const TRM_PATHS = {
  'jobs.onboarding': '/trm#/onboarding',
  'jobs.hiringplan': '/trm#/settings/hiring-plan-setup/hiring-plans',
  'people.trm-candidates': '/trm#/candidates',
  'jobs.internal-posting': '/trm#/internal-job-board',
  'jobs.aop': '/trm#/aop/overview',
  'trm-referral': '/trm#/referrals/jobs',
  'trm-career-page': '/trm#/settings/career-page',
  'dashboard.overview_trm': '/trm#/overview',
  'dashboard.approvals_trm': '/trm#/approvals',
  'jobs.trm': '/trm#/jobs',
} as const;

export function getFirstPathComponent(url: string): string {
  // Remove leading and trailing slashes and then split the URL path by '/'
  const parts = url.replace(/^\/|\/$/g, '').split('/');

  // The first part after splitting is the first component of the path
  if (parts[0] === '') {
    // If the URL had a leading '/', the first part after split will be an empty string
    // We want the first significant part, so let's check the next part
    if (parts.length > 1) {
      return parts[1];
    }
  }
  return parts[0];
}

export const getSelectedKey = (
  pathname: string,
  href: string = '',
  isTrmRoute: boolean = false,
): string => {
  if (isTrmRoute) {
    for (const key of Object.keys(startsWithTrmSelectedKeyMap)) {
      if (href.startsWith(key)) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '/trm#/onboarding': "jobs.onboarding"; readonly '/trm#/settings/hiring-plan-setup/hiring-plans': "jobs.hiringplan"; readonly '/trm#/internal-job-board': "jobs.internal-posting"; ... 7 more ...; readonly '/trm#/report-analytics': "analytics"; }'.
        return startsWithTrmSelectedKeyMap[key];
      }
    }
  }

  for (const key of Object.keys(startsWithSelectedKeyMap)) {
    if (pathname.startsWith(key)) {
      // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '/people/leads': "people.leads"; readonly '/people/lists': "people.lists"; readonly '/people/csv-lists': "people.lists"; readonly '/people/ats-lists': "people.lists"; readonly '/people': "people.candidates"; ... 13 more ...; readonly '/schedule': "analytics"; }'.
      return startsWithSelectedKeyMap[key];
    }
  }
  return getFirstPathComponent(pathname);
};

export const duotoneIconStyle = {
  '--fa-primary-color': colorIconPrimary,
  '--fa-secondary-color': colorIconSecondary,
  '--fa-primary-opacity': '1.0',
  '--fa-secondary-opacity': '1.0',
} as const;
